import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import createRootReducer from './Reducers/reducers';
import StateStorage from './Helpers/StateStorage';
import FormValueFilter from './Helpers/FormValueFilter';
import { screenResize } from './Actions/actions';
import priceChangeObserver from './Helpers/PriceChangeObserver';
import updateCertificateHolder from './Helpers/UpdateCertificateHolders';
import ReduxFormMiddleware from './Middleware/ReduxFormMiddleware';
import CheckoutPageMiddleware from './Middleware/CheckoutPageMiddleware';
import InitializeDataMiddleware from './Middleware/InitializeDataMiddleware';
import InitializeStatesMiddleware from './Middleware/InitializeStatesMiddleware';
import BodyClassMiddleware from './Middleware/BodyClassMiddleware';
import ApplicationPageMiddleware from './Middleware/ApplicationPageMiddleware';
import InitializeLoggedInUserMiddleware from './Middleware/InitializeLoggedInUserMiddleware';

const configureStore = function configureStore() {
  const store = createStore(
    createRootReducer(),
    // Load the stored state - preserves state on refreshes
    // Note that FormValueFilter is used to help convert stringified values back
    // to correct object types
    StateStorage.loadState(FormValueFilter),
    composeWithDevTools(
      applyMiddleware(
        InitializeDataMiddleware,
        InitializeStatesMiddleware,
        ApplicationPageMiddleware,
        BodyClassMiddleware,
        CheckoutPageMiddleware,
        ReduxFormMiddleware,
        InitializeLoggedInUserMiddleware,
        thunkMiddleware,
      ),
    ),
  );
  // Stored state subscribes to changes and updates store state
  StateStorage.subscribeToStore(store);
  return store;
};

const store = configureStore();

// mobile/desktop display of Summary container
store.dispatch(screenResize(window.innerWidth));

// Form change listener that triggers API query for new quote based on user input
priceChangeObserver(store);

// Listener that triggers API that updates certificate holder addresses based on user input
updateCertificateHolder(store);

export default store;
